import { StripeBillingPage } from '@/components/subscription'

export function BillingPage() {
  return <StripeBillingPage />
}
